// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_ProviderDetailResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/accounts/providers/{provider_code}
 *
 * Provider detail object (config + capabilities). Shape is passthrough from
 * providers_model->getByCode() and owned downstream.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsFranchises_ProviderDetailResponseDados = unknown[];

export type SubaccountsFranchises_ProviderDetailResponse = ApiResponse<SubaccountsFranchises_ProviderDetailResponseDados>;

registerResponseContract('SubaccountsFranchises_ProviderDetailResponse', {})
